import { writable } from 'svelte/store'

const config = writable({
  // backendURL: "http://192.168.43.214:5000",
  backendURL: "https://fabi-cc.onrender.com",
  currentUser: null,
  suppliers: null,
  customers: null,
  items: null,
  fstyles: null,
  cmts: null,
  departments: ["Cutting ", "Machining", "Branding ", "Quality Assurance", "Management"],
  stockTypes: ["Fabric", "Consumable", "Trim"],
  trims: ["Wash Label", "Button", "Tags", "Elastic", "Piping ", "Stripes", "Tape", "Numerals", "Zips", "Lables", "Elastic Cord", "Piping cord", "Studs", "Toggles", "Ribbing"],
  consumable: ["S/Race Paper", "Tissue paper", "Printing paper", "Sublimation Ink", "Wrapping Plastic", "Swing Tags", "Sellotape", "Sewing cotton", "Thinners", "Screen Printing Ink", "Teflon"],
  f: {
    equals: (a, b) => a.toLowerCase().trim().replaceAll(" ", "").replaceAll(/\W/g, '') == b.toLowerCase().trim().replaceAll(" ", "").replaceAll(/\W/g, ''),
    _has_: (a, b) => a.toLowerCase().trim().replaceAll(" ", "").replaceAll(/\W/g, '').includes(b.toLowerCase().trim().replaceAll(" ", "").replaceAll(/\W/g, '')),
    titleCase: (str) => {
      let splitStr = str.toLowerCase().split(' ');
      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    }
  }
});
export default config;